import React, { useEffect, useState } from "react";
import './TableMF.scss'
import Card from "../../../../../components/Atomsv2/Card/Card";
import Table from "../../../../../components/moleculesv2/Table/Table";
import Column from "../../../../../components/moleculesv2/Table/Column";
import Status from "../../../../../components/Atomsv2/Status/Status";
import { convertirFormatoFecha, formateoBasico } from "../../../../../utilidades/formateos";
import OptionsGroup from "../../../../../components/moleculesv2/OptionsGroup/OptionsGroup";


const TableMF = ({ data, loading }) => {
    const [selectedOption, setSelectedOption] = useState("todos");
    const [dataFiltrada, setDataFiltrada] = useState(data);
    const options = [
        { label: "TODOS", value: "todos" },
        { label: "ALTO", value: "alto" },
        { label: "MEDIO", value: "medio" },
        { label: "BAJO", value: "bajo" },
    ]
    useEffect(() => {
        if (selectedOption === "todos") {
            setDataFiltrada(data);
        }
        else if (selectedOption === "alto") {
            setDataFiltrada(data.filter(item => item.ID_NIVEL_FATIGA === 1));
        }
        else if (selectedOption === "medio") {
            setDataFiltrada(data.filter(item => item.ID_NIVEL_FATIGA === 2));
        }
        else if (selectedOption === "bajo") {
            setDataFiltrada(data.filter(item => item.ID_NIVEL_FATIGA === 3));
        }

    }, [selectedOption,data])

    const nivelFatiga = (rowData) => {
        const colores = {
            1: "error",
            2: "warning",
            3: "success"
        }
        return (
            <Status severity={colores[rowData.ID_NIVEL_FATIGA]}>{rowData.NIVEL_FATIGA}</Status>
        )
    }
    return (
        <div className="TableMF">
            <Card >

                <Table
                height="calc(100vh - 200px)"
                    header={
                        <OptionsGroup
                            options={options}
                            activeValue={selectedOption}
                            onSelect={setSelectedOption}
                        ></OptionsGroup>
                    }
                    data={dataFiltrada}
                    skeleton={loading}
                    globalFilter
                    showCounter={true}
                    download
                >
                    <Column sortable header="ID" value="ID" />
                    <Column sortable header="OPERADOR" value="NOMBRE" />
                    <Column sortable header="CLIENTE_PRINCIPAL" value="CLIENTE_PRINCIPAL" />
                    <Column sortable header="ID_NIVEL_FATIGA" value="ID_NIVEL_FATIGA" body={nivelFatiga} />
                    <Column tooltipHeader={'Descanso promedio nocturno en HORAS'} sortable header="DPN" value="DESC_PROM_NOCTURNO" />
                    <Column tooltipHeader={'Descanso MÍNIMO'} sortable header="DESC.MIN." value="MINIMO_DESC_NOCTURNO" />
                    <Column tooltipHeader={'Dias laborados'} sortable header="DL" value="DIAS_LABORADOS" />
                    <Column tooltipHeader={'Total de viajes'} sortable header="TOT.V" value="TOTAL_VIAJES" />
                    <Column sortable header="ULTIMO DESCANSO" value="FECHA_ULTIMO_DESCANSO" body={(rowData) => { return (rowData.FECHA_ULTIMO_DESCANSO ? convertirFormatoFecha(formateoBasico(rowData.FECHA_ULTIMO_DESCANSO)) : <Status severity='warning'>Sin fecha registrada</Status>) }} />
                    {/* <Column sortable header="COMENTARIO" value="COMENTARIO" /> */}

                </Table>
            </Card>
        </div>
    )
}
export default TableMF